import React from "react";
import Item from "./Item";

function Child({ menu, onClick, itemName, clicked, isParentActive }) {
  const { name, icon, label, route } = menu;
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <React.Fragment>
      {name === "Merit Reward and Recognation" && (
        <div
          style={{
            height: "1px",
            backgroundColor: "#e8e8e8",
            margin: "15px 0",
          }}
        />
      )}
      <li
        className="nav-item"
        style={{
          padding: "5px 1.5rem",
          backgroundColor: isParentActive ? "#2a447c" : "",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(41, 69, 124, 1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = isParentActive
            ? "#2a447c"
            : "transparent";
        }}
      >
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setIsOpen((prev) => !prev);
          }}
          className={`nav-link font-size-sm text-truncate accordion-toggle${isOpen ? "" : " collapsed"}`}
        >
          <div className="d-flex justify-content-between">
            <div
              className="d-flex justify-content-between"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "230px",
              }}
            >
              <i className={icon} style={{ alignSelf: "center" }}></i>
              <span className="ms-2 align-self-center">{label || name}</span>
            </div>
            <div className="float-end p-1">
              <i className="bi bi-chevron-down"></i>
            </div>
          </div>
        </a>
      </li>

      <div
        className={`collapse${isOpen ? " show" : ""}`}
        style={{
          backgroundColor: "white",
          boxShadow: "0 2px 8px rgba(0,0,0,0.45) inset",
          width: "100%",
          margin: 0,
          padding: 0,
        }}
      >
        <ul className="navbar-nav">
          {route.map((m, i) => (
            <Item
              key={i}
              menu={m}
              onClick={onClick}
              itemName={itemName}
              clicked={clicked}
            />
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
}

export default Child;
